import React from 'react';
import { Button, Row, Col, Tag } from 'antd';
import DetailItem from '../../../CSIComponents/DetailItem';
import PageContainer from '../../../CSIComponents/PageContainer';
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const TableDetailView = (props: any) => {
    return (
        <PageContainer>
        <div style={{width: '100%',marginTop: -15, background: '#fff', padding: '16px'}}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{margin: '0 10px 0 0'}}>
                    <Button className="db-edit-btn" onClick={() => {props.setCurrentFlag('table')}}>Back</Button>
                </div>
                <div>
                    <Button className="db-edit-btn" style={{background: '#004771', color: '#fff'}} onClick={() => {props.setCurrentFlag('edit')}}>Edit</Button>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                <div style={{fontWeight: 'bold',color: '#333'}}>{props.currentLine.name}</div>
            </div>
            <div style={{padding: '0 16px'}}>
                <Row>
                    <Col style={{marginBottom: '30px'}} span={8}>
                        <DetailItem value={props.currentLine.name} label='Rate Plan Name' />
                    </Col>
                    <Col style={{marginBottom: '30px'}} offset={2} span={8}>
                        <DetailItem value={props.currentLine.code}  label='Rate Plan Code' />
                    </Col>
                </Row>
                <Row style={{marginBottom: '30px'}}>
                    <DetailItem value={props.currentLine.description}  label='Description' />
                </Row>
                { isTagsDisplayed &&
                    <Row style={{marginBottom: '30px'}}>
                        <div style={{display:'inline-block', width:'100%'}}>
                            <div style={{width:'100%',fontSize:12,color:'#999999',height:'24px'}}>Selected Tags</div>
                            <div style={{width:'100%',  padding:'0 5px', fontSize:'14px', marginTop:'5px',}}>
                                {
                                    props.currentLine.tags&&props.currentLine.tags.split(' | ').map((item:any, index: any) => {
                                        return <Tag style={{marginBottom: 4}} key={index}>{item}</Tag>
                                    })
                                }
                            </div>
                        </div>
                    </Row>
                }
            </div>
        </div>
        </PageContainer>
    );
}


export default TableDetailView;
